// ITER264 — Expansion Project Session (frontend-only continuity).
//
// A single object held in sessionStorage that both City Intelligence and
// Site Intelligence read/write. Lifetime = browser tab. Zero backend
// state, zero permanent storage — that's deliberate (per the iteration
// brief: "Do NOT build permanent project storage yet").
//
// Schema:
// {
//   origin: 'city_intel' | 'site_intel_direct',
//   brief: { business_objective, concept_name, preferred_cuisines,
//            preferred_formats, price_for_two, target_segments,
//            target_audience_description, ... },
//   city:                  string,
//   address:               string,
//   selected_neighbourhood: { name, lat, lng, rank, ... } | null,
//   candidates:            [...],
//   rejected:              [...],
//   truncated:             [...],
//   seed_meta:             { ... },
//   seed_llm:              { ... },
//   current_stage:         'concept' | 'discovering' | 'decision'
//                          | 'explorer' | 'detail',
//   ts:                    number (epoch ms),
// }
//
// Public API:
//   getSession()          → object | null
//   setSession(obj)       → writes the full object (replaces)
//   mergeSession(patch)   → shallow-merges patch into the existing object
//   clearSession()        → removes the key entirely
//   hasCityIntelOrigin()  → boolean shorthand for the legacy EI Home
//
// All writes silently no-op if sessionStorage is unavailable
// (private mode, embedded webviews, etc.) — never throw.

const KEY = 'expansion_session';

export function getSession() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setSession(obj) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ...obj, ts: Date.now() }));
  } catch { /* noop */ }
}

export function mergeSession(patch) {
  const cur = getSession() || {};
  setSession({ ...cur, ...patch });
}

export function clearSession() {
  try {
    sessionStorage.removeItem(KEY);
  } catch { /* noop */ }
}

export function hasCityIntelOrigin() {
  const s = getSession();
  return !!(s && s.origin === 'city_intel');
}
